export default {
    'categories.activities': 'Activités',
    'categories.animals-nature': 'Animaux et nature',
    'categories.custom': 'Personnalisé',
    'categories.flags': 'Drapeaux',
    'categories.food-drink': 'Nourriture et boissons',
    'categories.objects': 'Objets',
    'categories.people-body': 'Personnes et corps',
    'categories.recents': 'Récemment utilisé',
    'categories.smileys-emotion': 'Visages et émotions',
    'categories.symbols': 'Symboles',
    'categories.travel-places': 'Voyages et lieux',
    'error.load': 'Échec du chargement des émojis',
    'recents.clear': 'Effacez les émojis récents',
    'recents.none': 'Vous n\'avez pas encore sélectionné d\'émojis.',
    'retry': 'Essayez à nouveau',
    'search.clear': 'Effacer la recherche',
    'search.error': 'Échec de la recherche d\'émojis',
    'search.notFound': 'Aucun émoji trouvé',
    'search': 'Rechercher des émojis...'
  };
  